import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import classNames from 'classnames';
import { Field, FieldProps } from 'formik';
import React from 'react';
import styles from './FormikSwitch.module.scss';
import { makeStyles } from '@material-ui/core';

type FormikSwitchFieldProps = {
    name: string;
    label: string;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    fullWidth?: boolean;
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
};

const useStyles = makeStyles({
    fullWidth: (props: FormikSwitchFieldProps) => {
        const classes: any = {};
        if (props.labelPlacement === 'start') classes.marginLeft = 0;
        if (props.labelPlacement === 'end') classes.marginRight = 0;
        return classes;
    }
});

export function FormikSwitch(props: FormikSwitchFieldProps) {
    const { labelPlacement, fullWidth, ...otherProps } = props;
    const dynamicStyles = useStyles(props);

    return (
        <Field
            name={otherProps.name}
            render={({ field, form }: FieldProps) => {
                const onChange = otherProps.onChange
                    ? otherProps.onChange
                    : (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                          form.setFieldTouched(field.name);
                          form.setFieldValue(field.name, checked);
                      };

                const readOnlyOrDisabled = otherProps.readOnly || otherProps.disabled;

                const showNotAllowedCursor = classNames(
                    { [styles.notAllowedCursor]: readOnlyOrDisabled },
                    { [styles.force]: readOnlyOrDisabled }
                );

                const fullWidthClass = classNames({
                    [styles.fullWidth]: fullWidth,
                    [dynamicStyles.fullWidth]: fullWidth
                });

                return (
                    <FormControlLabel
                        control={
                            <Switch
                                {...otherProps}
                                className={showNotAllowedCursor}
                                checked={field.value}
                                onChange={onChange}
                                data-test-id={`switch_${otherProps.name}`}
                            />
                        }
                        label={otherProps.label}
                        labelPlacement={labelPlacement}
                        classes={{ root: fullWidthClass }}
                    />
                );
            }}
        />
    );
}
